import { Injectable } from '@angular/core';
import { IPrimaryResourceUrlInformationService } from './interfaces/IPrimaryResourceUrlInformationService';
import { FactoryUrlInformationService } from './factory-url-information.service';
import { WorkspaceUrlInformationService } from './workspace-url-information.service';

@Injectable({
    providedIn: 'root'
})
export class PrimaryResourceUrlInformationService {
    private _primaryResourceService: IPrimaryResourceUrlInformationService;

    public get service(): IPrimaryResourceUrlInformationService {
        return this._primaryResourceService;
    }

    public constructor(
        private readonly _factoryUrlInformationBaseService: FactoryUrlInformationService,
        private readonly _workspaceUrlInformationService: WorkspaceUrlInformationService
    ) {
        this._primaryResourceService = __IS_A365__? this._workspaceUrlInformationService : this._factoryUrlInformationBaseService;
    }
}
